import { statisticPageState } from "service/shared/singletones/statisticPageService/statisticPage.state";

class Controller {
  public readonly state = statisticPageState;
}

export const statisticPageController = new Controller();
